export default "__VITE_ASSET__B41aiefI__"